// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { createContext, useContext } from 'react';

interface TimelinePaletteColor {
  solid: string;
  diagonal: string;
}

interface TimelinePalette {
  asset: TimelinePaletteColor;
  focus: TimelinePaletteColor;
  invalid: TimelinePaletteColor;
  project: TimelinePaletteColor;
  disabled: TimelinePaletteColor;
  assignment: TimelinePaletteColor;
}

interface TimelineData {
  palette: TimelinePalette;
}

export const TimelineContext = createContext<TimelineData | undefined>(
  undefined
);

/**
 * A React hook that provides access to the timeline context.
 */
export function useTimeline() {
  const context = useContext(TimelineContext);

  if (context === undefined) {
    const error = 'useTimeline must be used within a TimelineContext provider';

    throw new Error(error);
  }

  return context;
}
